import React from 'react'
import Navbar from './Navbar';
import Home from './Home';
import {
  Routes,
  Route
} from "react-router-dom";
import Footer from './Footer';
import Discover from './Discover'
import Seekers from './Seekers';
import Company from './Company';
import SignUp from './SignUp';
import Login from './Login';

const App = () => {
  return (
    <div>
      <Navbar/>
      <Routes>
        <Route exact path="/" element={<Home/>} />
        <Route exact path="/company" element={<Company/>} />
        <Route exact path="/seekers" element={<Seekers/>} />
        <Route exact path="/discover" element={<Discover/>}/>
        <Route exact path="/signup" element={<SignUp/>}/>
        <Route exact path="/login" element={<Login/>}/>
      </Routes>
      <Footer/>
    </div>
  )
}

export default App
